import { useParams } from 'react-router'

import { ComplianceFileView } from './ComplianceFileView'
import { ExpiryTimeline } from './ExpiryTimeline'
import { useVault } from './VaultContext'

/** Route components: each pins a kind so routes.tsx can stay `Component:` throughout. */

export function CarrierFilePage() {
  const { href } = useVault()
  return <ComplianceFileView kind="carrier" back={{ to: href(''), label: 'Vault' }} />
}

export function DriverFilePage() {
  const { entityId } = useParams()
  const { href } = useVault()
  return <ComplianceFileView kind="drivers" entityId={entityId} back={{ to: href(''), label: 'Vault' }} />
}

export function TruckFilePage() {
  const { entityId } = useParams()
  const { href } = useVault()
  return <ComplianceFileView kind="trucks" entityId={entityId} back={{ to: href(''), label: 'Vault' }} />
}

export function TrailerFilePage() {
  const { entityId } = useParams()
  const { href } = useVault()
  return <ComplianceFileView kind="trailers" entityId={entityId} back={{ to: href(''), label: 'Vault' }} />
}

export function TimelinePage() {
  return <ExpiryTimeline />
}
